
/**
Created by Dio on 17-9.
http://inhu.net
 */

(function() {
  "use strict";
  (function() {
    var NGUeditor, UEDITOR_SCRIPT_BASE, ueditorCallbacks, ueditorLoading;
    UEDITOR_SCRIPT_BASE = getUeditorScriptBase();

    function getUeditorScriptBase() {
      var scripts, script, src, i;
      scripts = document.getElementsByTagName("script");
      for (i = scripts.length - 1; i >= 0; i--) {
        script = scripts[i];
        src = script.getAttribute("src") || "";
        if (/localSrc\/ueditor-1\.4\.3\.3\/angular-ueditor\.js(?:\?.*)?$/.test(src)) {
          return script.src.replace(/angular-ueditor\.js(?:\?.*)?$/, "");
        }
      }
      return "localSrc/ueditor-1.4.3.3/";
    }
    ueditorCallbacks = [];
    ueditorLoading = false;

    function loadScript(src, callback) {
      var script;
      script = document.createElement("script");
      script.type = "text/javascript";
      script.src = src;
      script.onload = script.onreadystatechange = function() {
        if (!script.readyState || /loaded|complete/.test(script.readyState)) {
          script.onload = script.onreadystatechange = null;
          callback();
        }
      };
      script.onerror = function() {
        console.error("Failed to load " + src);
      };
      document.getElementsByTagName("head")[0].appendChild(script);
    }

    function loadUeditor(callback) {
      if (typeof UE !== "undefined" && UE.ui && UE.ui.Editor) {
        callback();
        return;
      }
      ueditorCallbacks.push(callback);
      if (ueditorLoading) {
        return;
      }
      ueditorLoading = true;
      window.UEDITOR_HOME_URL = window.UEDITOR_HOME_URL || UEDITOR_SCRIPT_BASE;
      loadScript(UEDITOR_SCRIPT_BASE + "ueditor.config.js", function() {
        loadScript(UEDITOR_SCRIPT_BASE + "ueditor.all.js", function() {
          var callbacks;
          ueditorLoading = false;
          callbacks = ueditorCallbacks.splice(0, ueditorCallbacks.length);
          angular.forEach(callbacks, function(done) {
            done();
          });
        });
      });
    }
    NGUeditor = angular.module("ng.ueditor", []);
    NGUeditor.directive("ueditor", [
      function() {
        return {
          restrict: "C",
          require: "ngModel",
          scope: {
            config: "=",
            ready: "=",
            afterSetContent: "=",
            editor: "="
          },
          link: function($S, element, attr, ctrl) {
            var _NGUeditor, _updateByRender;
            _updateByRender = false;
            _NGUeditor = (function() {
              function _NGUeditor() {
                var _self;
                _self = this;
                this.destroyed = false;
                $S.$on("$destroy", function() {
                  _self.destroyed = true;
                  if (_self.editorId && !attr.id && typeof UE !== "undefined" && UE.delEditor) {
                    UE.delEditor(_self.editorId);
                  }
                });
                this.bindRender();
                this.loadEditor();
                return;
              }

              /**
               * 初始化编辑器
               * @return {[type]} [description]
               */

              _NGUeditor.prototype.loadEditor = function() {
                var _self;
                _self = this;
                loadUeditor(function() {
                  if (!_self.destroyed) {
                    _self.initEditor();
                  }
                });
              };

              _NGUeditor.prototype.initEditor = function() {
                var _UEConfig, _editorId, _self;
                _self = this;
                if (typeof UE === 'undefined') {
                  console.error("Please import the local resources of ueditor!");
                  return;
                }
                _UEConfig = $S.config ? $S.config : {};
                _editorId = attr.id ? attr.id : "_editor" + (new Date().getTime());
                element[0].id = _editorId;
                this.editorId = _editorId;
                this.editor = new UE.ui.Editor(_UEConfig);
                if ($S.editor) {
                  $S.editor = this.editor;
                }
                this.editor.render(_editorId);
                this.editor.ready(function() {
                  _self.editorReady = true;
                  _self.editor.addListener("contentChange", function() {
                    ctrl.$setViewValue(_self.editor.getContent());
                    if (!_updateByRender) {
                      if (!$S.$$phase) {
                        $S.$apply();
                      }
                    }
                    _updateByRender = false;
                  });
                  //add 内容设置成功暴露给指令
                  _self.editor.addListener("afterSetContent", function() {
                    if (typeof $S.afterSetContent === "function") {
                      $S.afterSetContent(_self.editor);
                    }
                  });
                  //add 1.4.3 补丁形式 修复 禁止本地保存选项无效--这里只是不让显示了
                  _self.editor.addListener("showmessage", function(type, m) {
                       if (m['content'] == '本地保存成功') {
                           return true;
                       }
                   });

                  if (_self.modelContent && _self.modelContent.length > 0) {
                    _self.setEditorContent();
                  }
                  if (typeof $S.ready === "function") {
                    $S.ready(_self.editor);
                  }
                });
                return this.editor;
              };

              _NGUeditor.prototype.setEditorContent = function(content) {
                if (content == null) {
                  content = this.modelContent;
                }
                if (this.editor && this.editorReady) {
                  this.editor.setContent(content);
                }
              };

              _NGUeditor.prototype.bindRender = function() {
                var _self;
                _self = this;
                ctrl.$render = function() {
                  _self.modelContent = (ctrl.$isEmpty(ctrl.$viewValue) ? "" : ctrl.$viewValue);
                  _updateByRender = true;
                  _self.setEditorContent();
                };
              };

              return _NGUeditor;

            })();
            new _NGUeditor();
          }
        };
      }
    ]);
  })();

}).call(this);